import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { FormsModule } from '@angular/forms';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { StuloginComponent } from './stulogin/stulogin.component';
import { UserComponent } from './user/user.component';
import { UserResolver } from './user/user.resolver';
import { SignupComponent } from './signup/signup.component';

import { RouterModule } from '@angular/router';
import { rootRouterConfig } from './app.routes';
// import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
// import { UserComponent } from './user/user.component';
// import { UserResolver } from './user/user.resolver';
import { AuthGuard } from './core/auth.guard';
import { AuthadminGuard } from './adminauth/authadmin.guard';

import { AuthService } from './core/auth.service';
import { UserService } from './core/user.service';
import { ReactiveFormsModule } from '@angular/forms';
import { StuhomeComponent } from './stuhome/stuhome.component';
import { MainpageComponent } from './mainpage/mainpage.component';
import { AdminloginComponent } from './adminlogin/adminlogin.component';

const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDkpoDJAAU4_dOOMeihYLvbxJxDmasi2Ek",
    authDomain: "onlinelibrary-32db3.firebaseapp.com",
    databaseURL: "https://onlinelibrary-32db3.firebaseio.com",
    projectId: "onlinelibrary-32db3",
    storageBucket: "onlinelibrary-32db3.appspot.com",
    messagingSenderId: "355866195216"
  }
};

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    StuloginComponent,
    UserComponent,
    SignupComponent,
    StuhomeComponent,
    MainpageComponent,
    AdminloginComponent
  ],
  imports: [
    BrowserModule,FormsModule,AngularFirestoreModule,AngularFireModule,ReactiveFormsModule,AngularFirestoreModule, 
    AngularFireAuthModule,
    RouterModule.forRoot(rootRouterConfig, { useHash: false }),
    AngularFireModule.initializeApp(environment.firebase)
  ],
  providers: [AdminloginComponent,AuthadminGuard,AuthService, UserService,UserResolver, AuthGuard,AngularFirestore,AngularFireDatabase],
  bootstrap: [AppComponent]
})
export class AppModule { }
